<template>
  <div>
    <v-form ref="form" v-model="valid" lang="de">
      <div v-if="isSuccess === null">
        <p>
          Solltest du mehrere Anlagen für dein Training benötigen, reserviere
          diese bitte einzeln.
        </p>
        <h3>Anlage</h3>

        <v-select
          v-model="eventData.anlage"
          :items="categoryList"
          label="Sportanlage"
          :rules="anlageRules"
        ></v-select>

        <h3>Datum & Uhrzeit</h3>
        <v-row class="mb-0">
          <v-col class="pb-0">
            <datePickerField @update="(val) => (this.eventData.date = val)"
          /></v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col class="pt-0">
            <timePickerField
              label="Startzeit"
              @update="(val) => (this.eventData.start = val)"
              :rules="[(v) => !!v || 'Bitte wähle eine Startzeit']"
              required
            />
          </v-col>
          <v-col class="pt-0">
            <timePickerField
              label="Endzeit"
              :min="eventData.start"
              @update="(val) => (this.eventData.end = val)"
              :rules="[(v) => !!v || 'Bitte wähle eine Endzeit']"
              required
            />
          </v-col>
        </v-row>
        <h3>Verein</h3>

        <v-text-field
          v-model="eventData.name"
          :rules="nameRules"
          label="Vereinsname"
          required
        ></v-text-field>

        <v-text-field
          v-model="eventData.verantw"
          :rules="nameRules"
          label="Verantwortliche Person"
          required
        ></v-text-field>

        <v-text-field
          v-model="eventData.phone"
          label="Handynummer"
          :rules="phoneRules"
          required
        ></v-text-field>

        <v-text-field
          v-model="eventData.email"
          :rules="emailRules"
          label="E-Mail"
          required
        ></v-text-field>

        <v-spacer />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="validate"
            :disabled="isSending"
            :loading="isSending"
            >Anfrage senden</v-btn
          >
        </v-card-actions>
      </div>
    </v-form>
    <v-sheet v-if="isSuccess">
      <v-alert type="success">
        Erfolgreich gesendet. Du erhältst eine Bestätigung, sobald die Anfrage
        bearbeitet wurde.
      </v-alert>
      <v-btn @click="reset()">Weitere Anlage reservieren</v-btn>
    </v-sheet>
    <v-sheet v-if="error.isError">
      <v-alert type="error"> Fehler aufgetreten </v-alert>
      <p>
        Leider ist ein Fehler beim Senden aufgetreten. Bitte probiere es erneut
        und wende dich im Wiederholungsfall an mail@nativv.ch
      </p>
      <v-btn class="mt-4" @click="reset()">Erneut versuchen</v-btn>
    </v-sheet>
  </div>
</template>
<script>
// Mixins
import eventCategories from "@/mixins/eventCategories";
import createEvent from "@/mixins/createEvent";

//Components
import datePickerField from "@/components/Elements/datePicker";
import timePickerField from "@/components/Elements/timePicker";

export default {
  mixins: [eventCategories, createEvent],
  components: { datePickerField, timePickerField },

  data: () => ({
    valid: true,
    isSending: false,
    isSuccess: null,
    anlageRules: [(v) => v !== null || "Bitte wähle eine Anlage"],
    nameRules: [(v) => !!v || "Pflichtfeld"],
    emailRules: [
      (v) => !!v || "Pflichtfeld",
      (v) => /.+@.+\..+/.test(v) || "Ungültige E-Mail Adresse",
    ],
    phoneRules: [(v) => !!v || "Pflichtfeld"],
    eventData: {
      anlage: null,
      name: "",
      date: "",
      start: "",
      end: "",
      verantw: "",
      email: "",
      phone: "",
    },
  }),

  methods: {
    validate() {
      const validation = this.$refs.form.validate();
      if (validation) {
        this.createEvent(this.eventData);
        this.isSending = true;
        this.error.isError = false;
      }
    },
    reset() {
      this.$refs.form.reset();
      this.isSuccess = null;
    },
  },
};
</script>
